import React, { useState, useEffect, Fragment } from "react";
import { Popup } from "../../atoms/Popup";
import { Card, Row, Col, Typography, Button, Image, Space, message, Tag, Tooltip } from "antd";
import { DownloadOutlined, EditOutlined, EyeOutlined, FileTextOutlined } from "@ant-design/icons";
import { getPresignedImage, uploadDocumentMedia } from "../../../utils/media";
import PdfCascadeView from "../PDFViewer/pdfCascadeView";
import moment from "moment";
import axios from "axios";
import { leaseService } from "../../../configs/constants";
import { getDocumentKey } from "../../../configs/documents";
import PdfView from "../PDFViewer/pdvViewNew";
import { DeleteIcon } from "../../../assets/svg";
import { getBookingDetail, updateBooking } from "../../modules/BookingForm/ducks/actions";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

type documentType = {
  label: String;
  key: String;
  documentSent: Boolean;
  isSign: Boolean;
};

const GeneratedDoc = (props) => {
  const [visible, setVisible] = useState(false);
  const [trigger, setTrigger] = useState(0);
  const dispatch: any = useDispatch();
  const { title, data, documentId, LEASEID, onRemoveDocument, sendForEsignature } = props;

  const [document, setDocument] = useState<documentType>({
    label: "",
    key: "",
    documentSent: false,
    isSign: false,
  });
  const { leaseId = "" } = useParams();
  const { Title } = Typography;
  const [viewOrDownloadUrl, setViewOrDownloadUrl] = useState(null);
  const [customTitle, setCustomTitle] = useState(title);
  const [modalWidth, setModalWidth] = useState(850);
  const [status, setStatus] = useState("");
  const [sendForSignature, setSendForSignature] = useState(false);
  const [openFileView, setOpenFileView] = useState(false);

  useEffect(() => {
    if (data) {
      const doc: documentType = {
        label: data?.documentName,
        key: getDocumentKey(data?.documentName),
        documentSent: data?.sendToTenant,
        isSign: data?.signaturesPlaceholder,
      };
      setDocument(doc);
    }
  }, [data]);

  const updateDocument = async (values) => {
    const { file, signBy } = values;
    const payload = {
      documentId: documentId,
      signBy: signBy,
      requestFrom: "portal",
      type: "pdf",
      documentType: data?.documentName,
    };
    if (file) {
      const { data } = await uploadDocumentMedia({ file_asset: file });
      if (data?.result?.documentId) {
        payload.documentId = data?.result?.documentId;
        await updateDocumentAPI(payload);
      }
    } else {
      await updateDocumentAPI(payload);
    }
  };

  const updateDocumentAPI = async (payload) => {
    let endpt = "booking";
    if (data?.isLeasingDoc == true) endpt = "leasing";
    try {
      const url = `${leaseService}/${endpt}/updateSignDocument/${LEASEID}`;
      await axios.patch(url, payload);
      message.success("Successfully updated document");
      onClosePopUp();
      await dispatch(getBookingDetail(LEASEID));
    } catch (e) {
      const { response } = e;
      message.error(response?.data?.error);
    }
  };

  const onClosePopUp = () => {
    if (sendForSignature) {
      setSendForSignature(false);
      setModalWidth(850);
      setCustomTitle(title);
    } else {
      setVisible(false);
      setSendForSignature(false);
      setCustomTitle(title);
      setModalWidth(850);
    }
  };

  const onOpenPopUpHandler = async (documentId) => {
    let result = await getUrl(documentId, 2);

    if (result && result?.length > 0) {
      setTrigger(1);
      setVisible(true);
    }
  };

  const getUrl = async (data, type) => {
    // *****
    // type 1 mean view document
    // and 2 mean view in edit mode
    // ***

    try {
      const url = await getPresignedImage([data]);
      if (url && url.length > 0 && type === 1) {
        setOpenFileView(true);
        setViewOrDownloadUrl(url[0]);
        return url;
      } else if (url && url.length > 0) {
        setViewOrDownloadUrl(url[0]);
        setOpenFileView(false);
        return url;
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  const downloadUrl = async (docId = null) => {
    let documId = docId ? docId : documentId;
    const url = await getPresignedImage([documId], false);
    if (url && url.length > 0) {
      window.location.href = url[0];
    }
  };

  useEffect(() => {
    let status = "";
    const signBy = data?.signBy;
    const sendToTenant = data?.sendToTenant;
    if (data?.signaturesPlaceholder == true) {
      if (signBy && signBy === "both") status = "Signed By Both";
      else if (signBy && signBy === "landlord") status = "Signed By Landlord";
      else if (signBy && signBy === "tenant" && data?.documentName !== "settlmentReport") status = "Signed By Tenant";
      else if (sendToTenant === true && data?.documentName !== "settlmentReport") status = "Awaiting Tenant Signature";
      else if (sendToTenant === true && data?.documentName === "settlmentReport") status = "Sent to tenant";
      else status = "";
    }
    setStatus(status);
  }, [data?.signBy]);

  const sendDocument = () => {
    if (sendForEsignature && document.key) sendForEsignature(document.key);
  };


  const popup = [
    {
      content: <Image preview={false} width="100%" style={{ padding: "20px" }} src={viewOrDownloadUrl} />,
      width: 650,
      onCancel: onClosePopUp,
    },
    {
      title: (
        <Title level={3} className="mb-0">
          {(customTitle || title) ?? "Generated document"}
        </Title>
      ),
      content: (
        <PdfCascadeView
          pdf={viewOrDownloadUrl}
          downloadUrl={downloadUrl}
          signBy={data?.signBy}
          documentName={data?.documentName}
          sendForEsignature={sendDocument}
          documentSent={document?.documentSent}
          placeholder={document?.isSign}
          onSubmit={updateDocument}
          documentType={document?.key}
          setTrigger={setTrigger}
          setModalWidth={setModalWidth}
          setCustomTitle={setCustomTitle}
          setSendForSignature={setSendForSignature}
          sendForSignature={sendForSignature}
          signVia={data?.signVia}
        />
      ),
      width: modalWidth,
    },
  ];

  const popupProps = {
    closable: true,
    visibility: visible,
    title: popup[trigger]?.title,
    content: popup[trigger]?.content,
    width: popup[trigger]?.width,
    onCancel: () => onClosePopUp(),
  };

  const settlementReportSent = async () => {
    try {
      let body = {
        settlementReportToTenant: "yes",
        onlyBooking: true,
      };
      const response = await dispatch(updateBooking({ leaseId, body }));
      await dispatch(getBookingDetail(leaseId + `?moveout=yes`));
      message.success(response.data.message);
      props?.setSendSettlementReport(false);
      setOpenFileView(false);
    } catch (error) {
      message.error(error.response?.data?.error || error.response?.data?.message);
    }
  };
  return (
    <Fragment>
      <Card bordered={false} className="document-card">
        <Row gutter={24} justify="space-between" align="middle">
          <Col span={12} style={{ display: "flex" }}>
            <FileTextOutlined className="require-doc" />
            <Title level={5}>
              {`${title}`} ({data?.createdAt && moment(data?.createdAt).format("DD-MM-YYYY HH:mm:ss A")})
            </Title>
          </Col>

          <Col span={12}>
            <Row>
              <Col span={2}></Col>
              <Col
                span={10}
                style={{
                  display: "flex",
                  justifyContent: "end",
                  paddingRight: "20px",
                }}
              >
                <Space size={20}>
                  <Tooltip title="Edit" trigger="hover" showArrow={false}>
                    {data?.handleAction && (
                      <Button
                        type="link"
                        className="ef-action-btn"
                        onClick={() => {
                          data?.handleAction();
                        }}
                      >
                        <EditOutlined />
                      </Button>
                    )}

                    {!data?.handleAction && (
                      <Button type="link" className="ef-action-btn" onClick={() => onOpenPopUpHandler(documentId)}>
                        <EditOutlined />
                      </Button>
                    )}
                  </Tooltip>

                  <Tooltip title="Download" trigger="hover" showArrow={false}>
                    <Button type="link" className="ef-action-btn" onClick={async () => downloadUrl()}>
                      <DownloadOutlined />
                    </Button>
                  </Tooltip>
                  {/* <Space> */}
                  <Tooltip title="View" trigger="hover" showArrow={false}>
                    <Button type="link" className="ef-action-btn" onClick={async () => await getUrl(documentId, 1)}>
                      <EyeOutlined />
                    </Button>
                  </Tooltip>
                  {data?.remove === true && (
                    <Tooltip title="Delete" trigger="hover" showArrow={false}>
                      <Button type="link" className="ef-action-btn" onClick={onRemoveDocument}>
                        <DeleteIcon />
                      </Button>
                    </Tooltip>
                  )}
                </Space>
              </Col>
              <Col span={12}>
                {(data?.status || status) && (
                  <Tag className="ef-tag tag-pending">{data?.status ? data?.status : status}</Tag>
                )}
              </Col>
            </Row>
          </Col>
        </Row>
      </Card>
      <Popup style={{ padding: "22px 0px 24px" }} {...popupProps} destroyOnClose={true} />

      <PdfView
        pdfData={viewOrDownloadUrl || props?.sendSettlementReport?.url}
        openFileView={openFileView || props?.sendSettlementReport}
        setOpenFileView={setOpenFileView}
        setSendSettlementReport={props?.setSendSettlementReport}
        onClick={settlementReportSent}
      />
    </Fragment>
  );
};

export default GeneratedDoc;
